import { motion } from "framer-motion";
import "../styles/PartnersHero.css";

export default function HeroSection() {
  return (
    <section className="Partners-hero-section">
      <div className="partners-overlay">
        <motion.div
          className="partners-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          {" "}
          <h1 className="herosection-title">
            <span className="herosection-main-title">Nexa</span>
            <span className="herosection-subtitle"> Partners</span>
          </h1>
        </motion.div>
      </div>
    </section>
  );
}
